// Post Model
import {Model} from '@vuex-orm/core';
import Trophy from '@/resources/assets/js/vue/lib/models/Trophy';
import LiveRoom from '@/resources/assets/js/vue/lib/models/LiveRoom';
import moment from 'moment';
import LiveRoomParticipant from "./LiveRoomParticipant";

export default class HuddleEvent extends Model {
    static entity = 'events';

    static fields() {
        return {
            id: this.attr(null),
            user: this.attr({}),
            title: this.attr(''),
            type: this.attr('default'),
            description: this.attr(''),
            description_clean: this.attr(''),
            salespage: this.attr(''),
            color: this.attr(''),
            long: this.attr(''),
            lat: this.attr(''),
            full_address: this.attr(''),
            muncipality: this.attr(''),
            province: this.attr(''),
            street: this.attr(''),
            street_number: this.attr(''),
            postal_code: this.attr(''),
            country: this.attr(''),
            members_count: this.attr(0),
            invited_count: this.attr(0),
            declined_count: this.attr(0),
            start_date: this.attr(''),
            end_date: this.attr(''),
            online: this.attr(true),
            levels: this.attr([]),
            status: this.attr('public'),
            members: this.attr([]),
            founder: this.attr({}),
            participation: this.attr({}),
            channel_id: this.attr(''),
            slug: this.attr(''),
            permissions: this.attr([]),
            paid: this.attr(false),
            price: this.attr(''),
            all_day: this.attr(false),
            url: this.attr(''),
            url_title: this.attr(''),
            image: this.attr(''),
            allow_user_invites: this.attr(false),
            invitation: this.attr({}),
            past: this.attr(false),
            mine: this.attr(false),
            trophy_id: this.attr(null),
            trophy: this.attr(null),
            category: this.attr({}),
            category_id: this.attr(null),
            notify_all_users: this.attr(false),
            notify_all_members: this.attr(false),
            global_event: this.attr(false),
            memberSelection: this.attr([]),
            notifications: this.attr(true),
            live_room: this.attr(null),
            created_at: this.attr(''),
        };
    }

    static beforeCreate(model) {
        if (model.start_date !== '') {
            model.start_date = moment(model.start_date).format('MMMM DD, YYYY HH:mm');
        }

        if (model.end_date !== '') {
            model.end_date = moment(model.end_date).format('MMMM DD, YYYY HH:mm');
        }
    }

    static beforeUpdate(model) {
        model.category = EventCategory.find(model.category_id);

        if (model.start_date !== '') {
            model.start_date = moment(model.start_date).format('MMMM DD, YYYY HH:mm');
        }

        if (model.end_date !== '') {
            model.end_date = moment(model.end_date).format('MMMM DD, YYYY HH:mm');
        }
    }

    static apiConfig = {
        actions: {
            store(event) {
                return new Promise((resolve, reject) => {
                    const params = new URLSearchParams();

                    event.start_date = moment(event.start_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    event.end_date = moment(event.end_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    event.global_event = true;

                    this.post('/api/v3/events', event, {
                        params,
                        dataTransformer: (response) => {
                            Event.delete(item => item.id == null);
                            return response.data.data;
                        },
                        save: false,
                    }).then((response) => {
                        resolve(response.response.data.data);

                        const { data } = response.response.data;

                        data.mine = true;
                        data.recently_viewed = true;


                        HuddleEvent.insert({
                            data,
                        });

                    }).catch((error) => {
                        event.error = error.response.data;
                        reject(error.response.response.data);
                    });
                });
            },

            fetch(params, joined, save = true) {
                // return a promise with the result so we can use the pagination data
                return new Promise((resolve) => {
                    this.get('/api/v3/events', {
                        params,
                        save: false,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        if (save) {
                            const events = response.response.data.data;

                            if (joined === 'mine') {
                                events.forEach((ev) => {
                                    ev.mine = true;
                                });
                            }

                            HuddleEvent.insert({
                                data: events,
                            });
                        }

                        resolve(response);
                    });
                });
            },

            fetchPastEvents(pageSize, date, page = 1) {
                const params = new URLSearchParams();

                params.append('where_lt', `end_date:${date}`);
                params.append('page', page);
                params.append('size', pageSize);
                params.append('with', 'memberSelection');
                params.append('order_by', 'end_date:desc');

                return new Promise((resolve) => {
                    this.get('/api/v3/events', {
                        params,
                        save: false,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        const events = response.response.data.data;

                        events.forEach((ev) => {
                            if (ev.start_date !== '') {
                                ev.start_date = moment(ev.start_date).format('MMMM DD, YYYY HH:mm');
                            }

                            if (ev.end_date !== '') {
                                ev.end_date = moment(ev.end_date).format('MMMM DD, YYYY HH:mm');
                            }
                        });

                        /* HuddleEvent.insert({
                            data: events,
                        }); */

                        resolve(events);
                    });
                });
            },

            fetchBySlug(slug) {
                // create new search params that we will use for the call
                const params = new URLSearchParams();

                params.append('with', 'participation,participation.live_room_participant,guards,category,memberSelection,memberSelection.user,live_room.participants');
                params.append('find_by', 'slug');

                return new Promise((resolve, reject) => {
                    this.get(`/api/v3/events/${slug}`, {
                        params,
                        dataTransformer: response => response.data.data,
                        save: false,
                    }).then((response) => {
                        const { data } = response.response.data;

                        HuddleEvent.insert({
                            data,
                        });

                        if (data.trophy != null) {
                            Trophy.insert(
                                {
                                    data: data.trophy,
                                }
                            );
                        }

                        if (data.live_room != null) {
                            LiveRoom.insert(
                                {
                                    data: data.live_room,
                                }
                            );
                        }

                        if (data.participation && data.participation.live_room_participant != null) {
                            LiveRoomParticipant.insert(
                                {
                                    data: data.participation.live_room_participant,
                                }
                            );
                        }

                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            join(event_id) {
                return new Promise((resolve, reject) => {
                    axios.put(`/api/v3/events/${event_id}/join`).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            leave(event_id) {
                return new Promise((resolve, reject) => {
                    axios.put(`/api/v3/events/${event_id}/leave`).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            accept(event) {
                return new Promise((resolve, reject) => {
                    axios.post(`/api/v3/events/${event.id}/invite/${event.invitation.id}/accept`).then(() => {
                        resolve(true);
                    }).catch((err) => {
                        reject(err);
                    });
                });
            },

            decline(event, status) {
                return new Promise((resolve, reject) => {
                    axios.post(`/api/v3/events/${event.id}/invite/${event.invitation.id}/decline`, { status: status }).then(() => {
                        resolve(true);
                    }).catch(() => {
                        reject(false);
                    });
                });
            },

            save(event) {
                return new Promise((resolve, reject) => {
                    event.level_ids = event.levels.map(level => level.level_id);

                    const { start_date, end_date } = event;

                    event.start_date = moment(start_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    event.end_date = moment(end_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    this.put(`/api/v3/events/${event.id}`, event, {
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        event.start_date = moment(event.start_date, 'YYYY-MM-DD HH:mm:ss').format('MMMM DD, YYYY HH:mm');
                        event.end_date = moment(event.end_date, 'YYYY-MM-DD HH:mm:ss').format('MMMM DD, YYYY HH:mm');
                        resolve(response);
                    }).catch((error) => {
                        event.error = error.response.data;
                        reject(error.response.data);
                    });

                    setTimeout(() => {
                        event.start_date = start_date;
                        event.end_date = end_date;
                    }, 0);
                });
            },
        },
    }
}

window.HuddleEvent = HuddleEvent;